import { connectedStore } from '../../store';
import actions from '../actions';

function addCustomGradient(gradient) {
  const store = connectedStore.get();
  store.dispatch(actions.addCustomGradient(gradient));
}

export default addCustomGradient;
